import { useEffect, useState } from 'react';
import { STAGES } from '@app/constants/stages';
import { AudioPlayer } from '@app/components/exam/AudioPlayer';
import { TextArea } from '@app/components/common/inputs/Input/Input';
import * as S from './ListeningSummarizeSpokenText.styles';
import { AnswerSummarizeSpokenText } from '../../Answer/AnswerSummarizeSpokenText';
import useCountdownTimer from '@app/hooks/useCountdownTimer';
import useDebounce from '@app/hooks/useDebounce';
import { useTranslation } from 'react-i18next';
import CustomTextarea from '@app/components/exam/components/CustomTextarea';

interface Props {
  prepTime: number;
  audioQuestion: string;
  showAnswer: boolean;
  questionNumber: string;
  isFirstRender: React.MutableRefObject<boolean>;
  allowDrag: boolean;
  onAnswerChange?: (answer: string) => void;
  canStart: boolean;
  allowClipboardActions: boolean;
}

export const ListeningSummarizeSpokenText: React.FC<Props> = ({
  prepTime,
  audioQuestion,
  showAnswer,
  questionNumber,
  allowDrag,
  onAnswerChange,
  canStart,
  allowClipboardActions,
}) => {
  const { t } = useTranslation();
  const [stage, setStage] = useState<string | null>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const [answerContent, setAnswerContent] = useState<string>('');
  const debouncedAnswerContent = useDebounce(answerContent, 500);

  const wordCount = debouncedAnswerContent.trim().split(/\s+/).filter(Boolean).length;

  const { seconds, isRunning, start, reset } = useCountdownTimer({
    initialSeconds: prepTime,
    onComplete: () => {
      setStage(STAGES.PLAYING);
      setIsPlaying(true);
    },
  });

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false;
    //   showPermissionModal();
    // } else {
    //   initialize();
    // }
    initialize();
  }, [questionNumber]);

  useEffect(() => {
    if (onAnswerChange) onAnswerChange(debouncedAnswerContent);
  }, [debouncedAnswerContent, onAnswerChange]);

  // const showPermissionModal = () => {
  //   InfoModal({
  //     title: 'Additional permissions',
  //     content: 'Click the OK button to enable record audio.',
  //     onOk: () => {
  //       initialize();
  //     },
  //   });
  // };

  const initialize = () => {
    setAnswerContent('');
    setStage(null);
    setIsPlaying(false);
    reset();

    start();
    setStage(STAGES.START);
  };

  const handleEnded = () => {
    setIsPlaying(false);
    if (stage === STAGES.PLAYING) setStage(STAGES.COMPLETE);
  };

  return (
    <>
      <S.Wrapper>
        {/* {stage === STAGES.START && (
          <p>
            Beginning in <S.TextRed>{seconds}</S.TextRed> seconds
          </p>
        )}
        {stage === STAGES.PLAYING && <p>Status: playing...</p>}
        {stage === STAGES.COMPLETE && <p>Status: Completed</p>} */}
        <S.Box>
          <p className="font-bold mb-2">{t('page.mockTest.audioRecorder')}</p>
          {stage === STAGES.START && (
            <S.TextRed>
              {t('page.mockTest.beginning')} {seconds}
            </S.TextRed>
          )}
          {stage === STAGES.PLAYING && <S.TextRed>{t('page.mockTest.button.playing')}</S.TextRed>}
        </S.Box>
        <AudioPlayer
          audioQuestion={audioQuestion}
          onEnded={handleEnded}
          startPlaying={isPlaying}
          waitingTime={isRunning}
          allowDrag={allowDrag}
          style={{ background: '#F1F1F1', padding: '0.7rem 0.5rem' }}
          canStart={canStart}
        />
      </S.Wrapper>

      {/* <TextArea
        rows={10}
        placeholder="Please write your answer here"
        value={answerContent}
        onChange={(e) => setAnswerContent(e.target.value)}
        className="mt-5"
      />

      <div>
        Word count: <span style={{ color: wordCount > 70 ? 'red' : 'black' }}>{wordCount}</span>
        /70
      </div> */}

      <CustomTextarea onChange={(value) => setAnswerContent(value)} allowClipboardActions={allowClipboardActions} />

      <div className="mt-5">{showAnswer && <AnswerSummarizeSpokenText />}</div>
    </>
  );
};
